import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('domainsWeb', {
  customKeys: {
    list: 'domains',
  },
  customEndpoints: {
    list: '/domains',
  },
});
